import styled, { css } from 'styled-components';
import { calcOpacity } from 'utils/calcOpacity';

export const RatingAndTrips = styled.div<{
  scrolledValue: number;
  isSmallProfile: boolean;
}>`
  ${({ theme, scrolledValue, isSmallProfile }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${theme.spacing.km1};
    color: ${theme.color.icon.neutral.default};
    transition: opacity 0s;
    position: relative;
    z-index: 21;
    margin-bottom: ${theme.spacing.km3};

    ${isSmallProfile &&
    css`
      opacity: ${calcOpacity(110, scrolledValue, 50)};
      justify-content: center;
      z-index: 19;
    `}

    ${!isSmallProfile &&
    css`
      opacity: ${calcOpacity(30, scrolledValue, 0)};
      justify-content: flex-start;
    `}
  `}
`;
